import { HelpMessage } from 'utils/constants'
import CIMSTable from 'components/CIMSTable'
import { ConcreteCoreMeasurement } from '../../../types'
import { dateFormatter } from '../../../../../../../../../../../../../../utils/dateFormatter'

function FirstTable(record: ConcreteCoreMeasurement) {
  const help = HelpMessage.Concrete.ConcreteTestSetTracker.CoresTable
  return (
    <CIMSTable
      disable={{ showAll: true }}
      records={[record]}
      rowKey="globalId"
      size="small"
      columns={[
        {
          title: 'Measured By',
          help: help.MeasuredBy,
          width: 231,
          render: ({ technician }) => technician?.technicianName,
        },
        {
          title: 'Measured Date',
          help: help.MeasuredDate,
          width: 231,
          render: ({ measurementDate }) =>
            dateFormatter.simple(measurementDate),
        },
        {
          title: 'Thickness 1',
          help: help.Thickness1,
          width: 150,
          render: 'measuredThickness1',
        },
        {
          title: 'Thickness 2',
          help: help.Thickness2,
          width: 150,
          render: 'measuredThickness2',
        },
        {
          title: 'Thickness 3',
          help: help.Thickness3,
          width: 150,
          render: 'measuredThickness3',
        },
      ]}
    />
  )
}

export default FirstTable
